var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.53846,
    cy: 8.53846,
    r: 8.03846,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76848 12.4627C7.73771 12.4627 6.86463 12.105 6.14925 11.3897C5.43386 10.6743 5.07617 9.8012 5.07617 8.77043C5.07617 7.73966 5.43386 6.86659 6.14925 6.1512C6.86463 5.43582 7.73771 5.07812 8.76848 5.07812C9.29925 5.07812 9.80694 5.18774 10.2916 5.40697C10.7762 5.6262 11.1916 5.93966 11.5377 6.34736V5.07812H12.4608V8.30889H9.23002V7.38582H11.1685C10.9223 6.95505 10.5858 6.61659 10.1589 6.37043C9.73194 6.12428 9.26848 6.0012 8.76848 6.0012C7.99925 6.0012 7.3454 6.27043 6.80694 6.80889C6.26848 7.34736 5.99925 8.0012 5.99925 8.77043C5.99925 9.53966 6.26848 10.1935 6.80694 10.732C7.3454 11.2704 7.99925 11.5397 8.76848 11.5397C9.36079 11.5397 9.8954 11.3704 10.3723 11.032C10.8492 10.6935 11.1839 10.2474 11.3762 9.69351H12.3454C12.13 10.5089 11.6916 11.1743 11.03 11.6897C10.3685 12.205 9.61463 12.4627 8.76848 12.4627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.8dae838e343e518852ca45d26887ad3e.svg";
export { ForwardRef as ReactComponent };